import React from "react";
import { Container, Row, Col } from "reactstrap";
import styles from "./InventoryLevelsDetail.module.scss";
import InfoCard from "../../../../common/AdminCommonComponents/InfoCard/InfoCard";
import GeneralBackButton from "../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";

const InventoryLevelsDetail = () => {
    const generalInfoData = [
        { label: "Seller ID", value: "#1234" },
        { label: "Product SKU", value: "Full Name" },
        { label: "Product ID", value: "03417053723" },
        { label: "Product name", value: "$50.00" },
        { label: "Current Status", value: "Shipped" },
    ];

    const shippingInfoData = [
        { label: "Current Stock", value: "#1234" },
        { label: "Stock Status", value: "Full name" },
        { label: "Allocated for Orders", value: "Full name" },
        { label: "Available for new orders", value: "03417053723" },
        { label: "Last Restocked", value: "01/01/2025" },
    ];

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderDetailWrapper}>
                <GeneralBackButton />
                <h4 className={styles.mainHeading}>Inventory Levels for Fullfilment</h4>
                <Row className={styles.infoCardRow}>
                    <Col xxl={6}>
                        <div className={styles.InfoCardsConatainer}>
                            <InfoCard title="Basic Product Information" headerColor="#FBBD34" data={generalInfoData} />
                            <InfoCard title="Inventory Details" headerColor="#41B8E4" data={shippingInfoData} />
                        </div>
                    </Col>
                    <Col xxl={6} className={styles.actionBtnsColumn}>
                        <div className={styles.actionBtnsContainer}>
                            <h4 className={styles.sectionHeading}>Actions</h4>
                            <DynamicButton theme="sky-blue">Notify Seller</DynamicButton>
                            <DynamicButton theme="orange">Deactivate Product</DynamicButton>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default InventoryLevelsDetail;